import { render } from "./MPrediction.vue?vue&type=template&id=6d656210&scoped=true&ts=true"
import script from "./MPrediction.vue?vue&type=script&lang=ts"
export * from "./MPrediction.vue?vue&type=script&lang=ts"

import "./MPrediction.vue?vue&type=style&index=0&id=6d656210&lang=scss&scoped=true"

import exportComponent from "D:\\project\\anet\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d656210"]])

export default __exports__